import React from 'react';
import { FormControlLabel, Checkbox, Typography, Link, Box } from '@mui/material';

const ConsentCheckbox = ({
  document,
  checked,
  onChange,
  required = false,
  disabled = false,
  onViewDocument,
}) => (
  <Box sx={{ mb: 0.5 }}>
    <FormControlLabel
      control={
        <Checkbox
          checked={!!checked}
          onChange={(e) => onChange(document.id, e.target.checked)}
          disabled={disabled}
          size="small"
          sx={{ pt: 0.5, alignSelf: 'flex-start' }}
        />
      }
      label={
        <Typography variant="body2" sx={{ mt: 0.5 }}>
          {required && (
            <Typography component="span" color="error.main" fontWeight={700}>
              *{' '}
            </Typography>
          )}
          I have read and agree to the{' '}
          <Link
            component="button"
            type="button"
            variant="body2"
            fontWeight={600}
            onClick={(e) => {
              e.preventDefault();
              onViewDocument?.(document);
            }}
          >
            {document.title}
          </Link>
          {document.version && (
            <Typography component="span" variant="caption" color="text.secondary" sx={{ ml: 0.5 }}>
              (v{document.version})
            </Typography>
          )}
        </Typography>
      }
      sx={{ alignItems: 'flex-start', mx: 0 }}
    />
  </Box>
);

export default ConsentCheckbox;
